import React from 'react';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';

import Form, { FormTextField } from '@ts-core/core/components/FormV2';

import { SubjectFormInput } from '../../types/form';
import { Subject } from '../../types';

interface SubjectFormProps {
  onSubmit: (data: SubjectFormInput) => void;
  submitting?: boolean;
  submitError?: string;

  subject?: Subject;
}

const SubjectForm = (props: SubjectFormProps) => {
  const intl = useIntl();
  const { onSubmit, subject, submitting, submitError } = props;
  const { handleSubmit, control, formState } = useForm<SubjectFormInput>({
    defaultValues: {
      name: subject?.name,
    },
  });
  return (
    <Form formState={formState} onSubmit={handleSubmit(onSubmit)} isSubmitting={submitting} submitError={submitError} sx={{ width: '100%' }}>
      <FormTextField
        control={control}
        name="name"
        label={intl.formatMessage({ id: 'field.name.label' })}
        type="text"
        fullWidth
        rules={{ required: true }}
      />
    </Form>
  );
};

export default SubjectForm;
